const DEFAULT_DIVISIONS = 2;

// 0 or 1 = no breaks (hours only). Missing/invalid = default.
const parseDivisions = (value) => {
  if (value === null || value === undefined || value === '') return DEFAULT_DIVISIONS;
  const num = Number(value);
  if (Number.isNaN(num)) return DEFAULT_DIVISIONS;
  return Math.max(1, Math.floor(num));
};

export { DEFAULT_DIVISIONS, parseDivisions };